export const NUMBER_TYPE_FORMAT_WHOLE = "#,#";
export const NUMBER_TYPE_FORMAT_DECIMAL = "#,#.#";
export const NUMBER_TYPE_FORMAT_WHOLE_NO_COMMAS = "#";
export const NUMBER_TYPE_FORMAT_DECIMAL_NO_COMMAS = "#.#";
export const DEFAULT_NUMBER_TYPE_FORMAT = NUMBER_TYPE_FORMAT_WHOLE;
export const NUMBER_TYPE_FORMATS = [
  NUMBER_TYPE_FORMAT_WHOLE,
  NUMBER_TYPE_FORMAT_DECIMAL,
  NUMBER_TYPE_FORMAT_WHOLE_NO_COMMAS,
  NUMBER_TYPE_FORMAT_DECIMAL_NO_COMMAS,
] as const;

export function isDecimalNumberFormat(
  format: string | undefined | null
): boolean {
  return (
    format === NUMBER_TYPE_FORMAT_DECIMAL ||
    format === NUMBER_TYPE_FORMAT_DECIMAL_NO_COMMAS
  );
}

export function usesNumberCommaSeparators(
  format: string | undefined | null
): boolean {
  return (
    format === NUMBER_TYPE_FORMAT_WHOLE ||
    format === NUMBER_TYPE_FORMAT_DECIMAL ||
    format == null
  );
}
